// const data = [
//   { label: 'JAN', added: 20, dropped: 10, retained: 22 },
//   { label: 'FEB', added: 10, dropped: 24, retained: 20 },
//   { label: 'MAR', added: 50, dropped: 27, retained: 21 },
//   { label: 'APR', added: 10, dropped: 22, retained: 18 },
//   { label: 'MAY', added: 8, dropped: 28, retained: 24 }
// ];

const TripleAreaChartConfig = (
  data,
  xKey = 'label',
  addedKey = 'added',
  droppedKey = 'dropped',
  retainedKey = 'retained',
  addedLabel = 'Added',
  droppedLabel = 'Dropped',
  retainedLabel = 'Retained',
  addedColor = '#3B82F6',    // blue tone
  droppedColor = '#10B981',  // purple tone
  retainedColor = '#F59E0B'  // green tone
) => {
  const useDataZoom = data.length > 20;

  return {
    color: [addedColor, droppedColor, retainedColor],
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'cross' },
      formatter: (params) => {
        const a = params.find(p => p.seriesName === addedLabel);
        const d = params.find(p => p.seriesName === droppedLabel);
        const r = params.find(p => p.seriesName === retainedLabel);
        return `
          <b>${a?.name || d?.name || r?.name || ''}</b><br/>
           ${addedLabel}: ${a?.value ?? 0}<br/>
          ${droppedLabel}: ${d?.value ?? 0}<br/>
           ${retainedLabel}: ${r?.value ?? 0}
        `;
      }
    },
    grid: {
      left: 10,
      right: 10,
      bottom: useDataZoom ? 50 : 40,
      top: 20,
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: data.map(d => d[xKey]),
      boundaryGap: false,
      axisLabel: { interval: 0 }
    },
    yAxis: { type: 'value' },
    dataZoom: useDataZoom
      ? [
        { type: 'inside', xAxisIndex: 0, start: 0, end: 40 },
        { type: 'slider', show: false, xAxisIndex: 0, height: 15, bottom: 40 }
      ]
      : [],
    series: [
      {
        name: addedLabel,
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 6,
        data: data.map(d => d[addedKey]),
        lineStyle: { color: addedColor, width: 2 },
        itemStyle: { color: addedColor },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: `${addedColor}99` },
              { offset: 1, color: `${addedColor}00` }
            ]
          }
        },
        z: 3
      },
      {
        name: droppedLabel,
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 6,
        data: data.map(d => d[droppedKey]),
        lineStyle: { color: droppedColor, width: 2 },
        itemStyle: { color: droppedColor },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: `${droppedColor}99` },
              { offset: 1, color: `${droppedColor}00` }
            ]
          }
        },
        z: 2
      },
      {
        name: retainedLabel,
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 6,
        data: data.map(d => d[retainedKey]),
        lineStyle: { color: retainedColor, width: 2 },
        itemStyle: { color: retainedColor },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: `${retainedColor}99` },
              { offset: 1, color: `${retainedColor}00` }
            ]
          }
        },
        z: 1
      }
    ]
  };
};

export default TripleAreaChartConfig;
